<script>
export default {
    props: {
        title: {
            type: String,
            required: false,
            default: ''
        },
        articles: {
            type: Array,
            required: true
        },
        categories: {
            type: Array,
            required: true
        },
        forums: {
            type: Array,
            required: true
        },
        events: {
            type: Array,
            required: true
        },
        drugs: {
            type: Array,
            required: true
        },
        clinicalResearches: {
            type: Array,
            required: true
        },
        pages: {
            type: Array,
            required: true
        }
    },

    computed: {
        allTopics() {
            return [
                {
                    type: 'article',
                    items: this.articles
                },
                {
                    type: 'category',
                    items: this.categories
                },
                {
                    type: 'forum',
                    items: this.forums
                },
                {
                    type: 'event',
                    items: this.events
                },
                {
                    type: 'drug',
                    items: this.drugs
                },
                {
                    type: 'clinicalResearch',
                    items: this.clinicalResearches
                },
                {
                    type: 'page',
                    items: this.pages
                }
            ];
        }
    }
};
</script>
